import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import SupportView from "./SupportView";
import EditSupport from "./EditSupport";
import "../Common/Common.css";

var dateFormat = require("dateformat");

class Support extends Component {
  constructor(props) {
    super(props);
    this.paginationreset = React.createRef();
    this.state = {
      SupportShow: false,
      showEditModel: false,
      page: 0,
      perPage: 10,
      searchSupport: "",
      ItemList: "",
      filterValue: "",
    };
  }

  componentDidMount() {
    this.props.supportList({
      page: undefined,
      search: this.state.searchSupport,
      filter: this.state.filterValue,
    });
    this.props.fetchSupportType();
    this.props.fetchSupportUsers();
  }

  //For pagination
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.SupportSelectedPage({
      page: selectedPage + 1,
      search: this.state.searchSupport,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };

  //For search
  SearchOnChange = (event) => {
    this.setState(
      {
        filterValue: "",
        searchSupport: event.target.value,
        page: 0,
      },
      () => {
        this.props.supportList({
          page: undefined,
          search: this.state.searchSupport,
          filter: this.state.filterValue,
        });
      }
    );
  };

  //For filter
  handleChange = (event) => {
    this.setState(
      {
        filterValue: event.target.value,
        searchSupport: "",
        page: 0,
      },
      () => {
        this.props.supportList({
          page: undefined,
          search: this.state.searchSupport,
          filter: this.state.filterValue,
        });
      }
    );
  };

  //For detailed view - open modalbox
  handleSupportView = (item) => {
    this.setState({
      SupportShow: true,
      SupportDtls: item,
    });
  };

  //close modal box
  handleCloseSupportView = () => {
    this.setState({ SupportShow: false });
  };

  //For edit view - open modalbox
  handleEditSupport = (item) => {
    this.setState(
      {
        showEditModel: true,
        ItemList: item,
      },
      () => {
        this.props.fetchSupportHistory({
          page: undefined,
          sprtId: item.id,
        });
      }
    );
  };

  //Close edit modal
  closeEditModel = () => {
    this.setState({
      showEditModel: false,
    });
    this.paginationreset.current.resetitemPage();
  };

  render() {
    const count = this.props.supportDtlsCount && this.props.supportDtlsCount;
    let p = this.state.page + 1;
    let SupportPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Support</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    {this.props.supportTypeList &&
                      this.props.supportTypeList.map((item, i) => (
                        <option key={i} value={item.id}>
                          {item.supportType}
                        </option>
                      ))}
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Ticket Number"
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>TICKET NO</th>
                    <th>NAME</th>
                    <th>MOBILE</th>
                    <th>SUPPORT TYPE</th>

                    <th>DESCRIPTION</th>
                    <th>CREATED DATE & TIME</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.supportDtlsList &&
                    this.props.supportDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item.ticketNo !== null && item.ticketNo}
                        </td>
                        <td className="cmn_Cap">
                          {item &&
                            item.userId &&
                            item.userId.name !== null &&
                            item.userId.name}
                        </td>
                        <td className="cmn_Cap">
                          {item &&
                            item.userId &&
                            item.userId.mobileNo !== null &&
                            item.userId.mobileNo}
                        </td>
                        <td className="cmn_Cap">
                          {item &&
                            item.sprtType &&
                            item.sprtType.supportType !== null &&
                            item.sprtType.supportType}
                        </td>

                        <td className="cmn_Cap commonDesc">
                          {item.issueDesc !== null && item.issueDesc}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy, h:MM TT")
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item.status !== null && item.status}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleSupportView(item)}
                            ></i>
                            <SupportView
                              show={this.state.SupportShow}
                              handleClose={this.handleCloseSupportView}
                              SupportDtls={this.state.SupportDtls}
                            />

                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditSupport(item)}
                            ></i>
                            {/* <EditSupport
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                supportUsersList={this.props.supportUsersList}
                                addSupportHistory={this.props.addSupportHistory}
                                editSupport={this.props.editSupport}
                                supportHistoryList={
                                  this.props.supportHistoryList
                                }
                                supportHistoryCount={
                                  this.props.supportHistoryCount
                                }
                                handleHistoryPageClick={
                                  this.handleHistoryPageClick
                                }
                                pageHis={this.state.pageHis}
                                perPageHis={this.state.perPageHis}
                                resetHistoryPage={this.resetHistoryPage}
                              /> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <EditSupport
                ref={this.paginationreset}
                showEditModel={this.state.showEditModel}
                closeEditModel={this.closeEditModel}
                ItemList={this.state.ItemList}
                supportUsersList={this.props.supportUsersList}
                addSupportHistory={this.props.addSupportHistory}
                editSupport={this.props.editSupport}
                supportHistoryList={this.props.supportHistoryList}
                supportHistoryCount={this.props.supportHistoryCount}
                SupportHistorySelectedPage={
                  this.props.SupportHistorySelectedPage
                }
              />

              {(this.props.supportDtlsList === undefined ||
                (this.props.supportDtlsList &&
                  this.props.supportDtlsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Supports Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {SupportPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={SupportPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default Support;
